import { Link } from "react-router-dom";

export function SiteFooter() {
  return (
    <footer className="border-t mt-12 py-6 px-4" data-testid="site-footer">
      <div className="mx-auto max-w-5xl flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-muted-foreground">
        <span>© {new Date().getFullYear()} Pharmacie des Écoles</span>
        <nav className="flex flex-wrap items-center gap-x-5 gap-y-2">
          <Link to="/mentions-legales" data-testid="footer-mentions" className="hover:text-foreground">Mentions légales</Link>
          <Link to="/confidentialite" data-testid="footer-confidentialite" className="hover:text-foreground">Politique de confidentialité</Link>
          <Link to="/contact" data-testid="footer-contact" className="hover:text-foreground">Contact</Link>
          <Link to="/retirer-mon-consentement" data-testid="footer-retrait" className="hover:text-foreground">Retirer mon consentement</Link>
        </nav>
      </div>
    </footer>
  );
}
